module.exports = __webpack_public_path__ + "media/images/front/popular_contents_02-6789d27794ef8bd8d26b7c47673d1931.jpg";